module.exports = __webpack_public_path__ + "img/options-prisma.0a57026e.svg";